<template>
    <v-product-line-layout :group="group" :is-marketing="true">
        <slot slot="title">{{group.ErpId}} - {{group.Name}}</slot>
        <slot slot="product">

        </slot>
        <slot slot="variations">
            <v-marketing-variation-line :parent-id="parentId"
                                        v-for="product in group.Products"
                                        :product="product"
                                        :key="product.Id"
                                        :group="group"
                                        :group-index="groupIndex"
                                        :is-editable-field="isEditableField"
                                        :readOnly="readOnly">
            </v-marketing-variation-line>
        </slot>
    </v-product-line-layout>
</template>

<script>
    import debounce from 'lodash/debounce'
    import VGallery from '@/components/gallery/Gallery'
    import VSelect from '@/components/form/Select'
    import VInput from '@/components/form/Input'
    import VMarketingVariationLine from '@/components/product/common/MarketingVariationLine'
    import VProductLineLayout from '@/components/product/layout/ProductLineLayout'

    export default {
        props: {
            group: Object,
            parentId: String,
            groupIndex: Number,
            isEditableField: { type: Boolean, default: true },
            readOnly: {type: Boolean, default: false}
        },
        components: {
            VGallery,
            VSelect,
            VInput,
            VMarketingVariationLine,
            VProductLineLayout,
        },
        computed: {
            Images() {
                let output = !this.group.Images.length ? null : [];

                this.group.Images.forEach((image, index) => {
                    if (index < 6) {
                        output.push({
                            src: image.replace('[WIDTH]', 32).replace('[HEIGHT]', 32),
                            selected: index === 0
                        })
                    }
                });
                return output
            },
            isDisabled(){
                return this.group.IsDeleted;
            },
            MaximumDiscount() {
                let discount;
                if (this.group.MaximumDiscount) {
                    discount = this.group.MaximumDiscount.toString();
                } else {
                    discount = "0";
                }
                return discount;
            }
        },
        methods: {
            updateGroup: debounce(function () {
                this.$store.dispatch('updatePreOrderMarketingGroup', {
                    preOrderId: this.parentId,
                    productGroupId: this.group.Id,
                    body: {
                        Id: this.group.Id,
                        PreOrderDiscount: this.group.PreOrderDiscount
                    }
                }).then(() => {
                    this.$store.dispatch('getPreOrderById', this.$route.params.id);
                });
            }, 500)
        }
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/private";

</style>


// WEBPACK FOOTER //
// src/components/product/common/MarketingLine.vue